<template>
  <div
    v-if="!subscriptionIsFreeTrial && $store.state.idea.storyMode.common.completedSteps.otherOverheadsCompleted === true && isOtherOverheadsVisible"
    class="journal-content dynamic-height"
    :class="{'dynamic-height': !isOption(otherOverheadData, 'breakdownSection') && !isOption(otherOverheadData, 'timelineSection') && !isOption(otherOverheadData, 'tableSection')}"
  >
    <div class="content-menus">
      <div v-if="moreVisible === true" class="view-type">

        <template v-if="otherOverhead.length !== 0">
          <a
            class="orange"
            :class="{'orange-off': !isOption(otherOverheadData, 'breakdownSection')}"
            @click="enableBreakdown"
          >
            {{ $t('pages.businessPlan.sections.breakdown') }}
          </a>
          <a
            class="orange"
            :class="{'orange-off': !isOption(otherOverheadData, 'timelineSection')}"
            @click="enableTimeline"
          >
            {{ $t('pages.businessPlan.sections.timeline') }}
          </a>
          <a
            class="orange"
            :class="{'orange-off': !isOption(otherOverheadData, 'tableSection')}"
            @click="enableTable"
          >
            {{ $t('pages.businessPlan.sections.table') }}
          </a>
        </template>
        <p v-if="otherOverhead.length === 0">
          {{ $t('pages.businessPlan.sections.youDontHaveAnyDataOnThisPage') }}
        </p>
      </div>
      <div v-if="canEdit" class="mini-actions">
        <toggle-page-items-button
          :visible="moreVisible"
          @click="toggleMore"
        />
        <toggle-view-button
          :disabled="!cardExist"
          :horizontal="!isOption(otherOverheadData, 'gridListView')"
          @click="toggleRotate"
        />
        <toggle-notes-button
          :disabled="!moreDetails"
          :visible="isOption(otherOverheadData, 'moreDetailsDisplay')"
          @click="enableMoreDetails"
        />
        <edit-section-link route-name="business-guide-projections-other-overheads" />
      </div>
    </div>

    <div class="sub chapter">
      <header>
        <!-- Title section -->
        <editable-title
          v-model="otherOverheadData.title"
          tag="h1"
          :disabled="!canEdit || shareMode"
          @save="onSave"
        />
        <!-- Title section -->
        <hr>
        <!-- Description section -->
        <editable-description
          v-model="otherOverheadData.subTitle"
          :empty-text="$t('addMoreDetails.addNoteText')"
          :disabled="!canEdit || shareMode"
          @save="onSave"
        />
        <!-- Description section -->
      </header>

      <template v-if="otherOverhead.length !== 0">
        <!-- Breakdown chart -->
        <div v-if="isOption(otherOverheadData, 'breakdownSection')" class="switcher-inner-wrapper breakdown-chart">
          <other-overhead-breakdown
            :chart-adjustment="chartAdjustment"
            :update-chart="updateCharts"
          />
        </div>
        <!-- /Breakdown chart -->

        <!-- Timeline chart -->
        <div v-if="isOption(otherOverheadData, 'timelineSection')" class="switcher-inner-wrapper timeline-chart">
          <other-overhead-timeline
            :switch-selector="switchSelector"
            :chart-adjustment="chartAdjustment"
            :update-chart="updateCharts"
          />
        </div>
        <!-- /Timeline chart -->

        <!-- Finance Table -->
        <div v-if="isOption(otherOverheadData, 'tableSection')" class="switcher-inner-wrapper table-chart">
          <other-overhead-table
            :table-adjustment="tableAdjustment"
            :update-chart="updateCharts"
          />
        </div>
        <!-- /Finance Table -->
      </template>

      <!-- More Details section -->
      <template v-if="moreDetails && isOption(otherOverheadData, 'moreDetailsDisplay')">
        <div class="details">
          <editable-title
            v-model="otherOverheadData.moreDetailsTitle"
            class="bold"
            tag="p"
            :disabled="!canEdit"
            @save="onSave"
          />
          <p v-html="moreDetails" />
        </div>
      </template>
      <!-- More Details section -->
    </div>
  </div>
</template>

<script>
import EditSectionLink from '@/views/Home/StoryMode/Components/BusinessPlan/EditSectionLink'
import EditableDescription from '@/components/_v2/EditableDescription'
import EditableTitle from '@/components/_v2/EditableTitle'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import MixinUserSubscription from '@/mixins/permissions/userSubscription'
import OtherOverheadBreakdown from '@/views/Home/StoryMode/Forecast/OtherOverheads/Charts/OtherOverheadBreakdown'
import OtherOverheadTable from '@/views/Home/StoryMode/Forecast/OtherOverheads/Tables/OtherOverheadTable'
import OtherOverheadTimeline from '@/views/Home/StoryMode/Forecast/OtherOverheads/Charts/OtherOverheadTimeline'
import ToggleNotesButton from '@/views/Home/StoryMode/Components/BusinessPlan/ToggleNotesButton'
import TogglePageItemsButton from '@/views/Home/StoryMode/Components/BusinessPlan/TogglePageItemsButton'
import ToggleViewButton from '@/views/Home/StoryMode/Components/BusinessPlan/ToggleViewButton'
import journalMethods from '@/mixins/journalMethods'

export default {
  name: 'OtherOverheads',

  components: {
    EditSectionLink,
    EditableDescription,
    EditableTitle,
    OtherOverheadBreakdown,
    OtherOverheadTable,
    OtherOverheadTimeline,
    ToggleNotesButton,
    TogglePageItemsButton,
    ToggleViewButton
  },

  mixins: [
    journalMethods,
    MixinIdeaRoles,
    MixinUserSubscription
  ],

  props: {
    allPagesTextData: {
      type: Object,
      default: () => ({})
    },
    shareMode: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      otherOverheadData: {},
      cardExist: false,
      breakdownSection: true,
      timelineSection: true,
      tableSection: true,

      moreVisible: false,
      updateCharts: true,

      moreDetails: this.$store.state.idea.storyMode.common.moreDetails.otherOverheadsMoreDetails,
      otherOverhead: this.$store.state.idea.storyMode.forecast.otherOverheads.otherOverheads,

      chartAdjustment: {
        chartHeight: 260,
        headingTitleFontSize: '18px',
        xLabelTitleFontSize: '10px',
        yLabelTitleFontSize: '12px',
        yaxisLabelsMinWidth: {
          breakDown: 0,
          timeLine: 0
        }
      },
      tableAdjustment: {
        journalPage: true,
        period: 'yearly',
        tableFirstColumnWidth: 250,
        columnWidth: 118
      },
      switchSelector: 'overheads-'
    }
  },

  computed: {
    isOtherOverheadsVisible () {
      const index = this.$store.state.idea.journal.journalSwitchBars.indexOf(
        this.$store.state.idea.journal.journalSwitchBars.find(journalElement => journalElement.sectionName === 'OtherOverheads')
      )

      return !this.$store.state.idea.journal.journalSwitchBars[index].options.includes('switch')
    },

    isTitleEnabled () {
      return this.otherOverheadData.title
    },

    isMoreDetailsTitleEnabled () {
      return this.otherOverheadData.moreDetailsTitle
    },

    isOtherOverheadEmpty () {
      return this.$store.state.idea.storyMode.forecast.otherOverheads.otherOverheads.length === 0
    }
  },

  watch: {
    allPagesTextData () {
      this.otherOverheadData = Object.assign({}, this.allPagesTextData)
    }
  },

  mounted () {
    this.otherOverheadData = Object.assign({}, this.allPagesTextData)
  },

  methods: {
    toggleRotate () {
      if (this.cardExist) {
        this.toggleOption(this.otherOverheadData, 'gridListView')
        this.otherOverheadData = Object.assign({}, this.allPagesTextData)
        this.onSave()
      }
    },

    enableMoreDetails () {
      if (this.moreDetails) {
        this.toggleOption(this.otherOverheadData, 'moreDetailsDisplay')
        this.otherOverheadData = Object.assign({}, this.allPagesTextData)
        this.onSave()
      }
    },

    onSave () {
      this.$emit('save', this.otherOverheadData)
    },

    enableTimeline () {
      this.toggleOption(this.otherOverheadData, 'timelineSection')
      this.otherOverheadData = Object.assign({}, this.allPagesTextData)
      this.onSave()
    },

    enableBreakdown () {
      this.toggleOption(this.otherOverheadData, 'breakdownSection')
      this.otherOverheadData = Object.assign({}, this.allPagesTextData)
      this.onSave()
    },

    enableTable () {
      this.toggleOption(this.otherOverheadData, 'tableSection')
      this.otherOverheadData = Object.assign({}, this.allPagesTextData)
      this.onSave()
    }
  }
}
</script>
